import { useContext, useEffect } from "react";
import { EmailContext, Email } from "../context/EmailContext";
import { useState } from "react";
import { EmailModal } from "./EmailModal";
import { formatTimeAgo } from "@/utils/timeRelated";
import { EmptyInbox } from "./EmptyInbox";
import { Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const Emails = () => {
  const { emails, loading, fetchEmails } = useContext(EmailContext);
  const [selectedEmail, setSelectedEmail] = useState<Email | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmails();
  }, []);

  const handleEmailClick = (email: Email) => {
    setSelectedEmail(email);
  };

  const closeModal = () => {
    setSelectedEmail(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-lg h-12 w-12 border-4 border-black border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full mx-auto p-4 space-y-4 ">
      <div className="flex justify-end">
        <button
          onClick={() => navigate("/dashboard/newsletter/setup")}
          className="flex items-center gap-2 px-4 py-2 
            bg-white border border-black rounded-lg
            shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]
            hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
            hover:translate-x-[2px] hover:translate-y-[2px]
            transition-all"
        >
          <span className="font-medium">Newsletter Settings</span>
          <Settings size={20} />
        </button>
      </div>

      {emails.length === 0 ? (
        <EmptyInbox />
      ) : (
        <div className="space-y-4">
          <h1 className="text-2xl font-bold">Fresh off the press</h1>
          {[...emails]
            .sort(
              (a, b) =>
                new Date(b.created_at).getTime() -
                new Date(a.created_at).getTime()
            )
            .map((email: Email) => (
              <div
                key={email.id}
                onClick={() => handleEmailClick(email)}
                className={`
                bg-white border border-black rounded-lg p-5
                shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]
                hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
                hover:translate-x-[2px] hover:translate-y-[2px]
                transition-all cursor-pointer
                ${email.subject.includes("[Test]")}
              `}
              >
                <div className="flex flex-col gap-1 mb-3">
                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-medium text-black tracking-tight">
                      {email.subject}
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm truncate pr-4">
                    {email.body.replace(/<[^>]*>/g, "")}
                  </p>
                </div>

                <div className="flex items-center justify-between gap-3">
                  <span
                    className={`
                    inline-flex items-center px-3 py-1 
                    border rounded-md 
                    text-sm  tracking-tight
                    text-gray-700
                    ${
                      email.resend_id
                        ? "bg-green-200 border-green-500"
                        : "bg-red-200 border-red-500"
                    }
                  `}
                  >
                    {email.resend_id ? "✓ Delivered" : "Failed"}
                  </span>
                  <span className="text-sm text-gray-500 px-2 py-1 font-medium whitespace-nowrap">
                    {formatTimeAgo(new Date(email.created_at))}
                  </span>
                </div>
              </div>
            ))}
        </div>
      )}

      {selectedEmail && (
        <EmailModal email={selectedEmail} onClose={closeModal} />
      )}
    </div>
  );
};

export default Emails;
